import { Components } from '@/api/generated/api';
import { useReportGroup } from '@/composables/useReportGroup';
import { computed, ComputedRef, ref } from 'vue';

interface ICurrentReportGroupComposable {
  currentReportGroup: ComputedRef<Components.Schemas.ReportGroupDto | undefined>;
  setCurrentReportGroupId: (reportGroupId?: number) => void;
}

const currentReportGroupId = ref<number | undefined>(undefined);

export const useCurrentReportGroup = (): ICurrentReportGroupComposable => {
  const { allReportGroups } = useReportGroup();

  const currentReportGroup = computed<Components.Schemas.ReportGroupDto | undefined>(() => {
    return allReportGroups.value.find((sc) => sc.id === currentReportGroupId.value);
  });

  const setCurrentReportGroupId = (reportGroupId?: number): void => {
    currentReportGroupId.value = reportGroupId;
  };

  return {
    currentReportGroup,
    setCurrentReportGroupId,
  };
};
